
import React, { FC, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AppPaths } from "./app-paths.enum";
import { useSelector } from "react-redux";

import PageFallback from "@/lib/components/page-fallback";
import PageProgress from "@/lib/components/page-progress";

import { profileSelector } from "@/store/selectors/profile-selectors";

// ===== pages =========
const SignInPage = React.lazy(() => import(/* webpackChunkName: "page_sign-in" */ "@/pages/sign-in"));
// const HomePage = React.lazy(() => import(/* webpackChunkName: "page_home" */ "@/pages/home"));
const SpecialistsPage = React.lazy(() => import(/* webpackChunkName: "page_specialists" */ "@/pages/specialists"));
const OrganizationsPage = React.lazy(() => import(/* webpackChunkName: "page_organizations" */ "@/pages/organizations"));
const SettingsPage = React.lazy(() => import(/* webpackChunkName: "page_settings" */ "@/pages/settings"));
const UserSearchPage = React.lazy(() => import(/* webpackChunkName: "page_user-search" */ "@/pages/user-search"));

// ===== private route =========
const PrivateRoute: FC<{ element: any }> = ({ element: Element }) => {
  const { session } = useSelector(profileSelector);
  
  return session
    ? (<Suspense fallback={<PageFallback />}><Element /></Suspense>)
    : (<Navigate to={AppPaths.SIGN_IN} />);
};

const AppRoutes: FC = () => {
  return (
    <Routes>
      {/* Private */}
      <Route path={AppPaths.HOME_ALL} element={<PrivateRoute element={SpecialistsPage} />} />
      <Route path={AppPaths.Specialists_All} element={<PrivateRoute element={SpecialistsPage} />} />
      <Route path={AppPaths.OrganizationsAll} element={<PrivateRoute element={OrganizationsPage} />} />
      <Route path={AppPaths.UserSearch_All} element={<PrivateRoute element={UserSearchPage} />} />
      <Route path={AppPaths.Settings_All} element={<PrivateRoute element={SettingsPage} />} />

      {/* Public */}
      <Route
        path={AppPaths.SIGN_IN}
        element={<Suspense fallback={<PageProgress />}><SignInPage /></Suspense>}
      />

      {/* Default */}
      <Route path="*" element={<Navigate to={AppPaths.SIGN_IN} replace />} />
    </Routes>
  );
}

export default AppRoutes;
